import styled from 'styled-components';

const styledFAQs = styled.div`
.hedding{
    font-size: 24px;
    font-weight: bold;
    margin-bottom:30px;
}
h1{
    font-size: 24px;
    font-weight: bold
}
h2{
    font-size: 17px;
    font-weight: 600;
    margin-left: 10px
}
h3{
    font-size: 14px;
    font-weight: 600;
    color: #76b5f1;
    margin-left: 10px;
    cursor: pointer
}
p{
    font-size: 13px;
    font-weight: normal;
    margin-left: 13px;
    line-height: 1.4
}
a{
    text-decoration: none;
    color: #76b5f1
}
li{
    font-size: 13px;
    font-weight: normal;
    line-height: 1.4;
}

`;

export default styledFAQs;


// WEBPACK FOOTER //
// client/containers/FaQs/StyledFAQs.js